<template>
  <!--::banner topo::-->
  <section v-if="bannerTopo != ''" class="breadcrumb">
    <div class="img-avance">
      <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bg-img-fill" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb_iner">
            <div class="breadcrumb_iner_item">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ================ contato ================= -->
  <section class="contact-section area-padding">
    <div class="container">

      <div class="row pb-60">
        <div class="col-12">
          <h2 class="contact-title">Formulário de contato</h2>
        </div>
        <div class="col-lg-8">
          <form class="form-contact contact_form" method="post" id="contactForm" novalidate="novalidate">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <textarea v-model="formulario.mensagem" class="form-control w-100 placeholder hide-on-focus"
                    name="mensagem" id="mensagem" cols="30" rows="9" placeholder="Digite sua mensagem aqui"></textarea>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.nome" class="form-control placeholder hide-on-focus" name="nome" id="nome"
                    type="text" placeholder="Seu nome">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.email" class="form-control placeholder hide-on-focus" name="email"
                    id="email" type="email" placeholder="E-mail">
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <input v-model="formulario.assunto" class="form-control placeholder hide-on-focus" name="assunto"
                    id="assunto" type="text" placeholder="Assunto">
                </div>
              </div>
            </div>
            <div class="form-group mt-3">
              <button type="submit" @click.prevent="enviaremail()" class="button button-contactForm"
                style="color: #fff;">Enviar
                contato</button>
            </div>
          </form>
        </div>
        <div v-if="contato != ''" class="col-lg-4">
          <div class="media contact-info">
            
            <div class="media-body">
              <h3><a href="">Fale Conosco</a></h3><br>
              <p style="font-weight: 600;">{{ contato[0].itiCampoExtra1 }} </p>
              <p>Whatsapp: <a :href="'https://wa.me/' + contato[0].itiCampoExtra3.replace(/\D/g, '')"
                  target="_blank">{{ contato[0].itiCampoExtra3 }}</a></p>
              <p>Telefone: {{ contato[0].itiCampoExtra4 }}</p>
              <p>{{ contato[0].itiCampoExtra2 }}</p>
            </div>
          </div>

        </div>
      </div>

      <div v-if="contato != ''" class="d-none d-sm-block ">

        <iframe
          :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra6"
          width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>

      </div>

    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'ContatoView',

  components: {
  },

  data: () => ({
    bannerTopo: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      assunto: "",
      mensagem: ""
    }
  }),

  methods: {
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Garante Max",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra5,
          emailResposta: this.formulario.email,
          textoEmail:
            "Nome: " + this.formulario.nome + "<br>" +
            "E-mail: " + this.formulario.email + "<br>" +
            "Assunto: " + this.formulario.assunto + "<br>" +
            "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso("E-mail enviado com sucesso.")
              this.limparFormulario();
            }
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.assunto = '';
      this.formulario.mensagem = '';
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Max :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

  },

  created() {
    this.carregaMetas("---");

    // BANNER TOPO
    axios.get('/Process/InsInstitucional/institucional/51/topocontato/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('bannerTopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // CONTATO
    axios.get('/Process/InsInstitucional/institucional/52/dadosdecontato/0/x')
      .then(response => {
        this.contato = response.data;
        //console.log('contato')
        //console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>